module.exports = __webpack_public_path__ + "assets/review_tab.add9c892.svg";